import useElysiaStore from '@/app/elysia-store';

const AppAgentWelcome = () => {
  const description = useElysiaStore((state) => state.description);
  const name = useElysiaStore((state) => state.name);
  const uploadedIcon = useElysiaStore((state) => state.uploadedIcon);
  const appCreator = useElysiaStore((state) => state.appCreator);

  return (
    <div className={`app-heading-container`}>
      <div className="app-heading d-flex align-items-center">
        {uploadedIcon?.iconId && uploadedIcon?.iconUrl && (
          <div className="preview-icon-container d-flex align-items-center justify-content-center">
            <img src={uploadedIcon?.iconUrl} className="icon" alt="preview-icon" />
          </div>
        )}
        <div className="preview-content">
          <div className="header-greeting mb-0">{name}</div>
        </div>
      </div>
      {appCreator && <div className="app-creator">Created By - {appCreator}</div>}
      <div className="preview-greetings">{description}</div>
    </div>
  );
};

export default AppAgentWelcome;
